//#region libraries
// custom components
import { ForecastTable } from "_organisms";

// bootstrap
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { DateTime } from "_atoms";

// redux
import {
  selectDateToISO,
  setDate
} from "_redux/slices/prm-bookings/calendar";
import { useDispatch, useSelector } from "react-redux";
//#endregion

const ByFlightAnalytics = (props) => {

  //#region redux
  const dispatch = useDispatch();
  const analyticsDate = useSelector(selectDateToISO); // start date of the week
  //#endregion  

  return (
    <>
      {/* date picker */}
      <Row className="justify-content-md-center mt-2">
        <Col xs={9} />
        <Col md="auto" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <DateTime date={analyticsDate} setDate={(date) => { dispatch(setDate(date)) }} />
        </Col>
      </Row>

      {/* forecast table */}
      <ForecastTable />

    </>
  );
};
export default ByFlightAnalytics;
